import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  PLATFORM_OVERVIEW_PATH,
  PARTNER_CONSOLE_PATH,
  SURFACE_PARTNER,
  SURFACE_PLATFORM,
  rememberActiveSurface,
} from '../auth/postLoginRouting';

/**
 * Surface switcher (Partner Console ↔ Platform Console).
 * Distinct from PartnerSwitcher. Shown whenever the user has platform access.
 */
function ConsoleSwitcher() {
  const { hasPlatformAccess, memberships } = useAuth();
  const hasPartnerMembership = memberships.length > 0;

  if (!hasPlatformAccess) {
    return null;
  }

  if (!hasPartnerMembership) {
    return (
      <Button
        as={NavLink}
        to={PLATFORM_OVERVIEW_PATH}
        size="sm"
        variant="outline-light"
        className="text-decoration-none console-switcher-btn"
        onClick={() => rememberActiveSurface(SURFACE_PLATFORM)}
      >
        Platform Console
      </Button>
    );
  }

  return (
    <ButtonGroup size="sm" className="console-switcher-btn">
      <Button
        as={NavLink}
        to={PARTNER_CONSOLE_PATH}
        variant="outline-light"
        className="text-decoration-none"
        onClick={() => rememberActiveSurface(SURFACE_PARTNER)}
      >
        Partner Console
      </Button>
      <Button
        as={NavLink}
        to={PLATFORM_OVERVIEW_PATH}
        variant="outline-light"
        className="text-decoration-none"
        onClick={() => rememberActiveSurface(SURFACE_PLATFORM)}
      >
        Platform Console
      </Button>
    </ButtonGroup>
  );
}

export default ConsoleSwitcher;
